import { render } from "./Alignment.vue?vue&type=template&id=1c1836e9&scoped=true"
import script from "./Alignment.vue?vue&type=script&lang=js"
export * from "./Alignment.vue?vue&type=script&lang=js"

import "./Alignment.vue?vue&type=style&index=0&id=1c1836e9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1c1836e9"

export default script